import { AppService } from './AppService';

export class ContratService {
   appService = new AppService();
   //API_URL = 'http://localhost/sfrwebapp/api/'
   constructor() {
      //this.appService = 
      //const API_URL = 'http://localhost/sfrwebapp/api/'
   }

   validate(site, domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude=null,longitude=null,infrastructure=null,referenceAdresse=null,referenceImmeuble=null,infoRue=null,infoBatiment=null,infoEscalier=null,infoEtage=null,infoVille=null,infoCodePostal=null,contactMobile = null, contactFixe=null,listeIdOption=null,numero=null,rio=null,referencePrise=null,numeroRue=null,complementRue=null,porte=null,ensemble=null,codeInsee=null,idMobile=null,listeIdAccessoire=null, doccli_id=null, conservNum=null, codevendeur=null,offreChoisie=null,optionsChoisies=null,souscriptionId=null,id_eligibilite=null,libelleAdresse=null,fibre_numeroRue=null,fibre_rue=null,fibre_complementRue=null,fibre_ville=null,fibre_codePostal=null,fibre_codeInsee=null,fibre_dateacceptation=null,fibre_dateouverture=null,fibre_datecommercialisation=null,cable_referencePrise=null,cable_numeroVoie=null,cable_voie=null,cable_complementVoie=null,cable_batiment=null,cable_escalier=null,cable_etage=null,cable_ville=null,cable_codeRivoli=null,cable_codePostal=null,cable_codeInsee=null,wttx_cohesionNumerique=null,wttx_attCohesionNumerique=null,typedocIdent=null,iddocIdent=null,checkStatus=null,opMkt=null) { 

      const action =  'validate';
      return this.callContrat(action,site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt);
      
   }

   create(site, domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude=null,longitude=null,infrastructure=null,referenceAdresse=null,referenceImmeuble=null,infoRue=null,infoBatiment=null,infoEscalier=null,infoEtage=null,infoVille=null,infoCodePostal=null,contactMobile = null, contactFixe=null,listeIdOption=null,numero=null,rio=null,referencePrise=null,numeroRue=null,complementRue=null,porte=null,ensemble=null,codeInsee=null,idMobile=null,listeIdAccessoire=null, doccli_id=null, conservNum=null, codevendeur=null,offreChoisie=null,optionsChoisies=null,souscriptionId=null,id_eligibilite=null,libelleAdresse=null,fibre_numeroRue=null,fibre_rue=null,fibre_complementRue=null,fibre_ville=null,fibre_codePostal=null,fibre_codeInsee=null,fibre_dateacceptation=null,fibre_dateouverture=null,fibre_datecommercialisation=null,cable_referencePrise=null,cable_numeroVoie=null,cable_voie=null,cable_complementVoie=null,cable_batiment=null,cable_escalier=null,cable_etage=null,cable_ville=null,cable_codeRivoli=null,cable_codePostal=null,cable_codeInsee=null,wttx_cohesionNumerique=null,wttx_attCohesionNumerique=null,typedocIdent=null,iddocIdent=null,checkStatus=null,opMkt=null,codeDistributeur=null,referencePm=null,sessionSouscription) {      
      const action =  'create';
      return this.callContrat(action,site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,sessionSouscription);
   }

   callContrat(action,site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,sessionSouscription) {
      const url = this.appService.getApiUrl() + 'contrat/contrat.php';
      const params = {
         action:action,
         site:site,
         domaine:domaine,
         civilite: civilite,
         nom: nom,
         prenom: prenom,
         dateNaissance: dateNaissance,
         adresse: adresse,
         adresseComplement: adresseComplement,
         codePostal: codePostal,
         ville: ville,
         contactMail: contactMail,
         iban: iban,
         bic: bic,
         titulaireIban: titulaireIban,
         idOffre: idOffre,
         serviceType:serviceType,
         latitude: latitude,
         longitude: longitude,
         infrastructure: infrastructure,
         referenceAdresse: referenceAdresse,
         referenceImmeuble:referenceImmeuble,
         infoRue: infoRue,
         infoBatiment: infoBatiment,
         infoEscalier: infoEscalier,
         infoEtage: infoEtage,
         infoVille: infoVille,
         infoCodePostal: infoCodePostal,
         
         contactMobile: contactMobile,
         contactFixe: contactFixe,
         listeIdOption: listeIdOption,
         numero: numero,
         rio: rio,

         referencePrise: referencePrise,
         numeroRue: numeroRue,
         complementRue: complementRue,
         porte: porte,
         ensemble: ensemble,
         codeInsee: codeInsee,

         idMobile: idMobile,
         listeIdAccessoire: listeIdAccessoire,
         doccli_id: doccli_id,
         conservNum: conservNum,
         codevendeur: codevendeur,
         offreChoisie: offreChoisie,
         optionsChoisies: optionsChoisies,
         souscriptionId: souscriptionId,
         id_eligibilite: id_eligibilite,
         libelleAdresse: libelleAdresse,

         fibre_numeroRue: fibre_numeroRue,
         fibre_rue: fibre_rue,
         fibre_complementRue: fibre_complementRue,
         fibre_ville: fibre_ville,
         fibre_codePostal: fibre_codePostal,
         fibre_codeInsee: fibre_codeInsee,
         fibre_dateacceptation: fibre_dateacceptation,
         fibre_dateouverture: fibre_dateouverture,
         fibre_datecommercialisation: fibre_datecommercialisation,

         cable_referencePrise: cable_referencePrise,
         cable_numeroVoie: cable_numeroVoie,
         cable_voie: cable_voie,
         cable_complementVoie: cable_complementVoie,
         cable_batiment: cable_batiment,
         cable_escalier: cable_escalier,
         cable_etage: cable_etage,
         cable_ville: cable_ville,
         cable_codeRivoli: cable_codeRivoli,
         cable_codePostal: cable_codePostal,
         cable_codeInsee: cable_codeInsee,

         wttx_cohesionNumerique: wttx_cohesionNumerique,
         wttx_attCohesionNumerique: wttx_attCohesionNumerique,

         typedocIdent: typedocIdent,
         iddocIdent: iddocIdent,
         docCliCode: checkStatus,
         docCliMessage: '',
         opMkt: opMkt,
         codeDistributeur:codeDistributeur,
         referencePm:referencePm,
         sessionSouscription: sessionSouscription

      };
      return this.appService.post(url, { params })
         .then(function (response) {
            return response.data

         })
         .catch(function (error) {
            throw new Error(error);
      });
   }


   callContratMobile(site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,iban, bic,titulaireIban,serviceType,idOffre,listeIdOption,conservNum,numero,rio,contactMail,contactMobile, contactFixe,idMobile,listeIdAccessoire,simCode,doccli_id,codevendeur,offreChoisie,optionsChoisies,souscriptionId,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,sessionSouscription) {
      const url = this.appService.getApiUrl() + 'contrat/contrat.php';
      const params = {
         action:'create',
         site:site,
         domaine:domaine,
         civilite: civilite,
         nom: nom,
         prenom: prenom,
         dateNaissance: dateNaissance,
         adresse: adresse,
         adresseComplement: adresseComplement,
         codePostal: codePostal,
         ville: ville,
         iban: iban,
         bic: bic,
         titulaireIban: titulaireIban,
         serviceType:serviceType,
         idOffre: idOffre, 
         listeIdOption: listeIdOption,        
         conservNum: conservNum,
         numero: numero,
         rio: rio,         
         contactMail: contactMail,
         contactMobile: contactMobile,
         contactFixe: contactFixe,
         idMobile: idMobile,  
         listeIdAccessoire: listeIdAccessoire,
         simCode:simCode,
         doccli_id: doccli_id,
         codevendeur: codevendeur,
         offreChoisie: offreChoisie,
         optionsChoisies: optionsChoisies,
         souscriptionId: souscriptionId, 
         typedocIdent: typedocIdent,          
         iddocIdent: iddocIdent,
         docCliCode: checkStatus,     
         opMkt: opMkt,
         codeDistributeur:codeDistributeur,         
         docCliMessage: '',
         sessionSouscription: sessionSouscription


      };
      return this.appService.post(url, { params })
         .then(function (response) {
            return response.data

         })
         .catch(function (error) {
            throw new Error(error);
      });
   }

   getBicFromIban(site, domaine, iban) {
      /*if(userType == 'VAD'){
         const data = {err:false,params:{bic:null}};
         return data;
      }*/
    const url = this.appService.getApiUrl() + 'contrat/contrat.php';
    const params = {
      action:"getBicFromIban",
      site: site,
      domaine: domaine,
      iban:iban
    };
    return this.appService.post(url, { params })
       .then(function (response) {
          return response.data

       })
       .catch(function (error) {
          throw new Error(error);
    });
 }

 async checkEmail(email) {
        //console.log("checkemail");
   //const url = 'https://webapp.sfrcaraibe.fr/api/contrat/checkemail.php';
   const url = this.appService.getApiUrl() + 'contrat/checkemail.php';
   const params = {
       email:email
       //callbackUrl: this.appService.getApiUrl()+this.callBackUrlScan,
   };
   return this.appService.get(url,{params},2000)
       .then(function (response) {
           return response.data

       }).catch(function (error) {
           throw new Error(error);
           
       });
}

   
}